import Parts from '@/app/components/Parts'
import Head from 'next/head'

export default function ContactPage() {
  return (
    <>
      <Head>
        <title>Azul Agro - Peças</title>
        <meta name="description" content="Descubra a linha completa de peças da Azul Agro, projetadas para manter seus equipamentos agrícolas funcionando com máxima eficiência. Encontre peças de reposição, componentes e acessórios de alta qualidade para suas máquinas." />
        <link rel="preload" as="image" href={"https://gabcomercio.azureedge.net/azul-agro/desktop/parts/introSection.webp"} media="(min-width: 1140px)" />
        <link rel="preload" as="image" href={"https://gabcomercio.azureedge.net/azul-agro/tablet/parts/introSection.webp"} media="(min-width: 540px) and (max-width: 1139px)" />
        <link rel="preload" as="image" href={"https://gabcomercio.azureedge.net/azul-agro/mobile/parts/introSection.webp"} media="(max-width: 539px)" />
      </Head>
      <Parts />
    </>
  )
}
